export default __webpack_public_path__ + "static/media/regulatory--u-turn--g3.9d07cd2e.png";